<template>
	<div class="bg-gray-100 min-h-screen">
		<div class="w-full sticky top-0 z-50">
			<div class="flex items-center gap-4 bg-white px-4 py-3">

				<button class=" bg-transparent rounded-xl  text-main bg-slate-100 p-2.5 " @click="clicked = true">
					<MenuIcon class="size-5 opacity-50" />
				</button>
				<!-- <img src="@/assets/logo.png" alt="Logo"
					class="max-w-[120px] max-h-[64px] object-contain bg-transparent rounded-[12px]" /> -->
           <img v-if="isNULLImage" src="@/assets/logo.png" alt="" class="max-w-[120px] max-h-[64px] object-contain bg-transparent rounded-[12px]">
          <img v-else :src="companyLogo" alt="" class="max-w-[120px] max-h-[64px] object-contain bg-transparent rounded-[12px]">
			</div>
			<Drawer v-model="clicked">
  <template #title>
    <div class="flex items-center gap-3">
      
      <div class="min-w-0">
        <p class="text-sm font-semibold tex-content">
          Welcome, {{ userName }}
        </p>
      </div>
    </div>
  </template>

  <div class="px-4 pb-4">
    <div class="rounded-xl border border-slate-100 bg-white/70 backdrop-blur px-4 py-3">
      <p class="text-xs text-slate-500">Signed in as</p>
      <p class="text-sm font-medium text-content truncate">{{ userEmail }}</p>
    </div>

    <div class="mt-4 grid gap-2">
		<button
        class="w-full inline-flex items-center justify-center gap-2 h-11 rounded-lg bg-rose-50 text-rose-600 font-medium border border-rose-100 hover:bg-rose-100 transition"
        @click="logout"
		>
        Logout
	</button>
	<button
	  class="w-full inline-flex items-center justify-center gap-2 h-11 rounded-lg bg-white text-main text-sm font-medium  hover:shadow transition active:translate-y-[1px]"
	  @click="clicked = false"
	>
	  Close
	</button>
    </div>
  </div>
</Drawer>

		</div>

	   <div class="px-4 pt-6 pb-8">
          <p class="text-sm ">{{ setDays }},</p>
          <p class="text-xl font-semibold -mt-1">{{ userName }}</p>
        </div>

<!-- Today's Calls and Backlogs Section -->
<div class="grid grid-cols-2 gap-3 px-4 mb-4">
  <router-link
    :to="{name: 'TodaysCalls'}"
    class="group block focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400/30 active:scale-[0.99] rounded-2xl"
  >
    <div class="relative rounded-2xl p-[1px]">
      <div class="pointer-events-none absolute inset-1 rounded-2xl bg-gradient-to-l from-emerald-500 to-emerald-300 opacity-20 blur-2xl transition duration-300 group-hover:opacity-40"></div>
      <div class="rounded-2xl bg-gradient-to-r from-emerald-500 to-emerald-400 p-[1px]">
        <div class="relative rounded-2xl bg-white/95 backdrop-blur-[1px] px-4 py-4 shadow-sm transition-colors duration-200 group-hover:bg-white">
          <div class="flex items-center gap-3 mb-3">
            <div class="grid h-9 w-9 place-items-center rounded-xl bg-emerald-500/10 text-emerald-600">
              <TodaysCallsIcon class="h-5 w-5" />
            </div>
          </div>
          <span class="block font-semibold text-2xl text-emerald-600 mb-1">{{ todayCount }}</span>
          <span class="text-xs text-content font-medium">Today's Calls</span>
        </div>
      </div>
    </div>
  </router-link>

  <router-link
    :to="{name: 'Backlogs'}"
    class="group block focus:outline-none focus-visible:ring-2 focus-visible:ring-rose-400/30 active:scale-[0.99] rounded-2xl"
  >
    <div class="relative rounded-2xl p-[1px]">
      <div class="pointer-events-none absolute inset-1 rounded-2xl bg-gradient-to-l from-rose-500 to-rose-300 opacity-20 blur-2xl transition duration-300 group-hover:opacity-40"></div>
      <div class="rounded-2xl bg-gradient-to-r from-rose-500 to-rose-400 p-[1px]">
        <div class="relative rounded-2xl bg-white/95 backdrop-blur-[1px] px-4 py-4 shadow-sm transition-colors duration-200 group-hover:bg-white">
          <div class="flex items-center gap-3 mb-3">
            <div class="grid h-9 w-9 place-items-center rounded-xl bg-rose-500/10 text-rose-600">
              <BacklogsIcon class="h-5 w-5" />
            </div>
          </div>
          <span class="block font-semibold text-2xl text-rose-600 mb-1">{{ blCount }}</span>
          <span class="text-xs text-content font-medium">Backlogs</span>
        </div>
      </div>
    </div>
  </router-link>
</div>

		<router-link to="/expiringlease" class="block mx-4 mb-4 group">
  <div class="relative rounded-2xl p-[1px]">
   
    <div
      class="pointer-events-none absolute inset-1 rounded-2xl bg-gradient-to-l from-[#ff6b6b] to-[#ffd6d6] opacity-30 blur-3xl transition duration-300 group-hover:opacity-60">
    </div>

    
    <div class="rounded-2xl bg-gradient-to-r from-[#ff6b6b] to-[#ffd6d6] p-[1px]">
    
      <div class="relative rounded-2xl bg-white/95 backdrop-blur-[1px] px-5 py-5 flex items-center justify-between shadow-sm transition-colors duration-200 group-hover:bg-white">
        <div class="flex items-center gap-4">
          <div class="grid h-10 w-10 place-items-center rounded-xl bg-[#ff6b6b]/10 text-[#ff6b6b]">
            <ExpiringLease class="h-5 w-5" />
          </div>
          <div>
            <p class="text-content text-base font-semibold">Expiring Lease</p>
            <p class="text-sm text-gray-500">Leases ending soon</p>
          </div>
        </div>
        <div class="flex items-center gap-3">
          <span class="flex items-center justify-center min-w-[2.25rem] h-9 rounded bg-[#ff6b6b]/10 text-[#1a2e2b] text-sm font-semibold ">
            {{ expiringLeaseCount }}
          </span>
          <RightArrow class="h-7 w-7 text-gray-600 transition-transform duration-200 group-hover:translate-x-0.5" />
        </div>
      </div>
    </div>
  </div>
</router-link>


		<div class="px-4">
<div class="mt-12">
  <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
    <router-link
      to="/projects"
      class="group block focus:outline-none focus-visible:ring-2 focus-visible:ring-[#00cdac]/30 active:scale-[0.99] rounded-2xl"
    >
      <div class="relative rounded-2xl p-[1px]">
        <div class="absolute inset-0 rounded-2xl bg-gradient-to-r from-[#00cdac] to-[#62EC14] opacity-10 blur-md transition group-hover:opacity-20"></div>
        <div class="relative rounded-2xl bg-white/90 backdrop-blur px-5 py-5 flex items-center justify-between shadow-sm transition-colors group-hover:bg-white">
          <div class="flex items-center gap-4">
            <div class="grid h-10 w-10 place-items-center rounded-xl bg-[#00cdac]/10 text-[#00cdac]">
              <Project class="h-5 w-5" />
            </div>
            <div>
              <p class="text-content text-base font-semibold">Projects</p>
              <p class="text-xs text-gray-500">Manage and add projects</p>
            </div>
          </div>
          <RightArrow class="h-7 w-7 text-gray-600 transition-transform duration-200 group-hover:translate-x-0.5" />
        </div>
      </div>
    </router-link>

    <router-link
      to="/properties"
      class="group block focus:outline-none focus-visible:ring-2 focus-visible:ring-[#62EC14]/30 active:scale-[0.99] rounded-2xl"
    >
      <div class="relative rounded-2xl p-[1px]">
        <div class="absolute inset-0 rounded-2xl bg-gradient-to-r from-[#62EC14] to-[#00cdac] opacity-10 blur-md transition group-hover:opacity-20"></div>
        <div class="relative rounded-2xl bg-white/90 backdrop-blur px-5 py-5 flex items-center justify-between shadow-sm transition-colors group-hover:bg-white">
          <div class="flex items-center gap-4">
            <div class="grid h-10 w-10 place-items-center rounded-xl bg-[#62EC14]/10 text-[#62EC14]">
              <Properties class="h-5 w-5" />
            </div>
            <div>
              <p class="text-content text-base font-semibold">Properties</p>
              <p class="text-xs text-gray-500">Browse and update listings</p>
            </div>
          </div>
          <RightArrow class="h-7 w-7 text-gray-600 transition-transform duration-200 group-hover:translate-x-0.5" />
        </div>
      </div>
    </router-link>

    <router-link
      to="/enquiry"
      class="group block focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400/30 active:scale-[0.99] rounded-2xl"
    >
      <div class="relative rounded-2xl p-[1px]">
        <div class="absolute inset-0 rounded-2xl bg-gradient-to-r from-amber-400 to-amber-300 opacity-10 blur-md transition group-hover:opacity-20"></div>
        <div class="relative rounded-2xl bg-white/90 backdrop-blur px-5 py-5 flex items-center justify-between shadow-sm transition-colors group-hover:bg-white">
          <div class="flex items-center gap-4">
            <div class="grid h-10 w-10 place-items-center rounded-xl bg-amber-500/10 text-amber-600">
              <Enquiry class="h-5 w-5" />
            </div>
            <div>
              <p class="text-content text-base font-semibold">Enquiry</p>
              <p class="text-xs text-gray-500">Track customer queries</p>
            </div>
          </div>
          <RightArrow class="h-7 w-7 text-gray-600 transition-transform duration-200 group-hover:translate-x-0.5" />
        </div>
      </div>
    </router-link>

    <router-link
      to="/agreement"
      class="group block focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400/30 active:scale-[0.99] rounded-2xl"
    >
      <div class="relative rounded-2xl p-[1px]">
        <div class="absolute inset-0 rounded-2xl bg-gradient-to-r from-indigo-500 to-indigo-400 opacity-10 blur-md transition group-hover:opacity-20"></div>
        <div class="relative rounded-2xl bg-white/90 backdrop-blur px-5 py-5 flex items-center justify-between shadow-sm transition-colors group-hover:bg-white">
          <div class="flex items-center gap-4">
            <div class="grid h-10 w-10 place-items-center rounded-xl bg-indigo-500/10 text-indigo-600">
              <Agreement class="h-5 w-5" />
            </div>
            <div>
              <p class="text-content text-base font-semibold">Agreement</p>
              <p class="text-xs text-gray-500">Contracts and documents</p>
            </div>
          </div>
          <RightArrow class="h-7 w-7 text-gray-600 transition-transform duration-200 group-hover:translate-x-0.5" />
        </div>
      </div>
    </router-link>
  </div>
</div>
		
		</div>
    <div class="text-center mt-12">
        <p class="text-[10px]">© 2025 Developed by Corelto | All rights reserved.</p>
      </div>
	</div>
</template>
<script>
import Drawer from '@/components/Drawer.vue';
import ExpiringLease from '@/components/icons/ExpiringLease.vue';
import Project from '@/components/icons/Project.vue';
import Properties from '@/components/icons/Properties.vue';
import Enquiry from '@/components/icons/Enquiry.vue';
import Agreement from '@/components/icons/Agreement.vue';
import MenuIcon from '@/components/icons/Menu.vue';
import RightArrow from '@/components/icons/RightArrow.vue';
import TodaysCallsIcon from '@/components/icons/TodaysCalls.vue';
import BacklogsIcon from '@/components/icons/Backlogs.vue';
export default {
	components: { 
		Drawer,
		ExpiringLease,
		Project,
		Properties,
		Enquiry,
		Agreement,
		MenuIcon,
		RightArrow,
		TodaysCallsIcon,
		BacklogsIcon
	},
  data() {
    return {
      clicked: false,
      expiringLeaseCount: 0,
      todayCount: 0,
      blCount: 0
    }
  },
  created() {
    // Fetch dashboard data for Today's Calls and Backlogs
    this.$axios
      .get("mobile_crm/dashboard")
      .then(res => {
        this.todayCount = res.data.todays_call || 0;
        this.blCount = res.data.backlogs || 0;
      })
      .catch(err => console.error('Dashboard API error:', err));
    
    // Fetch expiring lease count
    this.$axios.get(`mobile_crm/agreements/expiring_lease_count?expiring=true`)
      .then((res) => {
        this.expiringLeaseCount = res.data || 0;
        this.$store.dispatch('setAdvSParams', {});
      })
      .catch((err) => console.error('Expiring lease API error:', err));
  },
  computed: {
    userName() {
      return this.$store.getters.usersMaster?.name || 'User';
    },
    userEmail() {
      return this.$store.getters.usersMaster?.email || 'user@gmail.com';
    },
    setDays() {
      const hour = new Date().getHours();
      if (hour < 12) return 'Good Morning';
      if (hour < 17) return 'Good Afternoon';
      return 'Good Evening';
    },
    isNULLImage() {
      return !this.$store.getters.settingsMaster?.logo_path;
    },
    companyLogo() {
      return this.$store.getters.settingsMaster?.logo_path || '';
    }
  },
  methods: {
  
    logout() {
      localStorage.removeItem('property-user-token');
      this.$router.push('/login');
    }
  }
}
</script>
<style scoped>
.home-bg {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);

}

.home-icon {
  background-image: url('@/assets/home-bg.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  height: 200px;
  margin-top: 20px;
}

.text-main {
  color: #263238;
}

.text-content {
  color: #172F45;
}

.text-red {
  color: #CE4A4A;
}

.bg-main {
  background-color: #263238;
}

.bg-content {
  background-color: #172F45;
}

.bg-primary {
  background-color: #4183E0;
}

.bg-secondary {
  background-color: #D0D0D0;
}

.bg-success {
  background-color: #65B976;
}

.bg-red {
  background-color: #CE4A4A;
}

.bg-background {
  background-color: #f5f5f5;
}

.border-inputBorder {
  border-color: #EBEBEB;
}

.border-divider {
  border-color: #F0F0F0;
}

.border-primary {
  border-color: #4183E0;
}
</style>
